"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiKeysStatus = void 0;
const apiKeysStatus = exports.apiKeysStatus = {
  INACTIVE: 'inactive',
  PENDING: 'pending',
  ERROR: 'error',
  SUCCESS: 'success'
};